import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DayOfWeekPeriodString } from '@/pages/menu-managements/business-hours/service';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuHourService } from '@/services/BrandMenuHour/MenuManagementBrandMenuHourService';

export type ShowBrandMenuHourResponse = {
  id: string;
  title: Title;
  memo: string | null;
  day_of_week_periods: DayOfWeekPeriodString[];
};

export const useMenuManagementBrandMenuHourShow = async (
  id: string
): Promise<ShowBrandMenuHourResponse> => {
  const menuManagementBrandMenuHourService =
    new MenuManagementBrandMenuHourService(getClient());
  try {
    const res = await menuManagementBrandMenuHourService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
